import { z } from "zod";
import { zArr, zObj, zStr } from "./zodWrapper.js";
export var FrontEndKey;
(function (FrontEndKey) {
    FrontEndKey["MAPBOX_KEY"] = "MAPBOX_KEY";
    FrontEndKey["WINDY_KEY"] = "WINDY_KEY";
})(FrontEndKey || (FrontEndKey = {}));
export const FrontEndKeyEnum = z.nativeEnum(FrontEndKey);
export const GetEnvVariablesArgs = zObj({
    keys: zArr(FrontEndKeyEnum),
});
export const EnvVariable = zObj({
    key: FrontEndKeyEnum,
    value: zStr(),
});
export const EnvVariables = zArr(EnvVariable);
//# sourceMappingURL=envVariables.js.map